module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/chevron-left.svg?1b09d02465a2cf98fbcef56db3646c76";